import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { uniqueId, isEmpty } from 'lodash/fp';

import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/Info';
import IconButton from '@material-ui/core/IconButton';
import Link from '@material-ui/core/Link';

import { EwsOutlineIcon } from '../../../assets/svg/Icon';
import EwsColor from '../../../components/color/ews/EwsColor';
import { styles, StyledBadge } from '../style';

const useStyles = makeStyles(styles);

export default function EarlyWarningList(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [count, setCount] = useState();

  const {
    datas, handleEarlyWarningDetailList, handleOpenLegend, mobilemode,
  } = props;

  useEffect(() => {
    if (!isEmpty(datas)) {
      if (datas.summary?.evacuate) {
        setCount(datas.summary.evacuate);
      }
    }
  }, [datas]);

  const renderEws = (dataList) => (
    <>
      {dataList !== undefined && Object.entries(dataList).sort().map(([text, value]) => {
        const status = EwsColor(text);
        return (
          <Grid item key={uniqueId()}>
            <Box
              className={`${classes.listsBox}`}
              style={{
                color: status.color.constrastColor,
                backgroundColor: status.color.statusColor,
              }}
            >
              <Link href="http://ews.dwr.go.th" target="_blank" title="http://ews.dwr.go.th">
                {`${status.color.label} ${value}`}
              </Link>
            </Box>
          </Grid>
        );
      })}
    </>
  );

  return (
    <>
      <Box className={mobilemode ? classes.boxViewMobile : classes.boxViewCrisis}>
        <Box display="flex" justifyContent="flex-end">
          <Box>
            <Box display="flex" alignItems="center">
              <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                <IconButton
                  id="disaster_detail"
                  disabled={count <= 0}
                  onClick={mobilemode ? null : handleEarlyWarningDetailList(datas)}
                >
                  <StyledBadge
                    id="main-disaster-click"
                    badgeContent={count}
                    overlap="circular"
                    color="secondary"
                  >
                    <EwsOutlineIcon style={{ color: 'white' }} />
                  </StyledBadge>
                </IconButton>
              </Box>
              <Box id="dialog_disaster" display="flex" alignItems="center">
                <Box pl={1}>
                  <IconButton
                    id="legend-ews"
                    className={classes.btn}
                    onClick={handleOpenLegend(t('ระบบเตือนภัยล่วงหน้า'), 'ews')}
                  >
                    <InfoIcon style={{ fontSize: 13, color: '#777' }} />
                  </IconButton>
                </Box>
                <Box p={1}>
                  <Typography className={classes.titleBox}>{t('เตือนภัยน้ำหลากดินถล่ม (EWS)')}</Typography>
                </Box>
                <Box>
                  <Typography className={classes.timeBox}>
                    {!isEmpty(datas) && datas.time }
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box>
              <Grid id="dialog_disaster_list_provinces" container justifyContent="flex-start" spacing={1} className={classes.contentBox}>
                {isEmpty(datas) ? null
                  : (
                    <>
                      {(count <= 0)
                        ? (
                          <Grid item>
                            <Box
                              className={`${classes.listsBox}`}
                              style={{ backgroundColor: '#FFFFFF50', fontWeight: 'bold' }}
                            >
                              {t('ปกติ')}
                            </Box>
                          </Grid>

                        ) : renderEws(datas.summary)}
                    </>
                  )}
              </Grid>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

EarlyWarningList.defaultProps = {
  mobilemode: false,
};

EarlyWarningList.propTypes = {
  datas: PropTypes.instanceOf(Object).isRequired,
  handleEarlyWarningDetailList: PropTypes.func.isRequired,
  handleOpenLegend: PropTypes.func.isRequired,
  mobilemode: PropTypes.bool,
};
